import React from "react";
import { toRichHtml, withMarkdownEmphasis } from "./richText";
import "./richText.css";

export default function RichTextDisplay({ value, className = "", renderText }) {
  if (renderText) {
    const container = document.createElement("div");
    container.innerHTML = withMarkdownEmphasis(toRichHtml(value || ""));
    const render = (node, key) => node.nodeType === Node.TEXT_NODE
      ? <React.Fragment key={key}>{renderText(node.textContent, Boolean(node.parentElement?.closest("a")))}</React.Fragment>
      : React.createElement(node.tagName.toLowerCase(), {
        key, ...(node.tagName === "A" ? { href: node.getAttribute("href"), title: node.getAttribute("title") } : {}),
        ...(node.tagName === "OL" ? { start: node.getAttribute("start") } : {}),
      }, ...(node.tagName === "BR" ? [] : Array.from(node.childNodes).map(render)));
    return <div className={`rich-text-content ${className}`}>{Array.from(container.childNodes).map(render)}</div>;
  }
  return <div className={`rich-text-content ${className}`} dangerouslySetInnerHTML={{ __html: withMarkdownEmphasis(toRichHtml(value || "")) }} />;
}
